
import { Event } from '@process-advisor/process-miner/api/events';
import { getEventEmitter } from '@process-advisor/process-miner/processMiner/processMiner';

export type Props = {
    props: {
        variant: number,
        activity: number,
        from: number,
        to: number,
        discovery_rule_id: number,
        discovery_rule_type: string,
        object_type: string,
        object_name: string,
        series_name: string,
        source; string,
    }
}

export const openProcessAnalyticsModal = ({ props }:  Props) => {
    let eventEmitter = getEventEmitter()
    eventEmitter.emit(Event.openProcessAnalyticsModal, { props });
};
